import { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Button, Input, FormGroup, Label, Alert } from "reactstrap";
import ApiCall from '../utils/apis';

// Keys de Binance del usuario: con ellas operan todos sus bots
const Settings = () => {
  const [current, setCurrent] = useState(null);
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");
  const [testnet, setTestnet] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    async function fetchKeys() {
      const res = await ApiCall({ call: `settings/keys`, method: "GET" });
      if (res && !res.error) {
        setCurrent(res);
        setTestnet(!!res.testnet);
      }
    }
    fetchKeys();
  }, []);

  const save = async () => {
    setSaving(true);
    setMessage(null);
    const res = await ApiCall({ call: `settings/keys`, params: { apiKey, apiSecret, testnet }, method: "PUT" });
    setSaving(false);
    if (!res) {
      setMessage({ color: 'danger', text: 'No se pudo conectar con el servidor' });
    } else if (res.error) {
      setMessage({ color: 'danger', text: res.error });
    } else {
      setCurrent(res);
      setApiKey("");
      setApiSecret("");
      setMessage({ color: 'success', text: 'Keys guardadas y verificadas con Binance' });
    }
  };

  return (
    <Card className="shadow" style={{ marginTop: 20, maxWidth: 640 }}>
      <CardHeader className="border-0">
        <h3 className="mb-0">⚙️ Keys de Binance</h3>
      </CardHeader>
      <CardBody>
        {message && <Alert color={message.color} toggle={() => setMessage(null)}>{message.text}</Alert>}
        <p className="text-muted">
          {current && current.configured
            ? <>Key actual: <b>{current.apiKey}</b> {current.testnet ? '(testnet)' : '(producción)'}</>
            : 'Aún no has configurado tus keys. Sin ellas no puedes crear bots.'}
        </p>
        <FormGroup>
          <Label>API Key</Label>
          <Input type="text" autoComplete="off" value={apiKey} onChange={e => setApiKey(e.target.value)} />
        </FormGroup>
        <FormGroup>
          <Label>API Secret</Label>
          <Input type="password" autoComplete="new-password" value={apiSecret} onChange={e => setApiSecret(e.target.value)} />
        </FormGroup>
        <FormGroup check className="mb-3">
          <Label check>
            <Input type="checkbox" checked={testnet} onChange={e => setTestnet(e.target.checked)} /> Keys de testnet
          </Label>
        </FormGroup>
        <Button color="primary" disabled={!apiKey || !apiSecret || saving} onClick={save}>
          {saving ? 'Verificando…' : 'Guardar'}
        </Button>
        <p className="text-muted mt-3 mb-0" style={{ fontSize: 13 }}>
          La key debe tener permiso de trading spot y, si restringes por IP, permitir la IP del servidor.
          No actives permiso de retiro. El secret se guarda cifrado y no se vuelve a mostrar.
          Para cambiar las keys, primero detén tus bots.
        </p>
      </CardBody>
    </Card>
  );
};

export default Settings;
